export default "__VITE_ASSET__BDrSV6pL__"